import { render, staticRenderFns } from "./addressLookup.vue?vue&type=template&id=64ed9e2f&scoped=true"
import script from "./addressLookup.vue?vue&type=script&lang=js"
export * from "./addressLookup.vue?vue&type=script&lang=js"
import style0 from "./addressLookup.vue?vue&type=style&index=0&id=64ed9e2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ed9e2f",
  null
  
)

export default component.exports